import { required } from 'vuelidate/lib/validators';

const validations = {
  title: {
    required,
  },
};

export default validations;
